import DashboardIcon from '../icons/grid_icon'
import WeeklyRefresh from '../WeeklyRefreshCC'
import { useParams } from "react-router-dom";

export default function FleetExecutions(){
    const params = useParams();
    return(
        <section className='content'>
            <div className='first-row'>
                <div className='container-icon'>
                    <DashboardIcon width='17px' height='17px' fill='white' />
                </div>
                <h1>Weekly Refresh Command Center</h1>
            </div>
            <div className='table-container'>
                <WeeklyRefresh fleet_execution_id={params.fleet_execution_id} />
            </div>
        </section>
    )
}
